// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_g9-0";
export var animationContainer = "_g9-1";
export var modalContent = "_g9-2";
export var orderName = "_g9-3";
export var refundOption = "_g9-4";
export var refundOptionsContainer = "_g9-5";